import React from 'react';
import { ReactNode } from "react";
import NavBar_v03Responsive from '../component-library/NavBar_v03a_Responsive_component';

import Features_v01 from '../component-demos/Features_v01';
import Features_v01Accordian from '../component-library/Features_accordian_v01_component';
import MetricsRow_v01 from '../component-library/MetricsRow4Columns_v01_component';

import Carousel_v01 from '../component-demos/Carousel_v01';
import Carousel_v02 from '../component-demos/Carousel_v02';
import Carousel_v03 from '../component-demos/Carousel_v03';
import Carousel_v05 from '../component-demos/Carousel_v05';
import Carousel_v07_responsive from "../component-demos/Carousel_v07_responsive";
import Carousel_v06_basic from '../component-library/Carousel_v06_Basic_Component';

import HalfImageHalfText from '../component-demos/HalfImageHaflText_v01';
import { IAppConfig } from "../App_v01_Interfaces";
import { IMetricsRowData } from "../App_v01_Interfaces";
import { IItemList, IItem, IItemFact } from '../App_v01_Interfaces';




import {homePage_carouselItems_Vending} from "./App_v01_SundanceVending_ConfigData";



interface AppConfigProps{
  appConfig: IAppConfig;
}//end:

interface FeatureListProps{
  appFeatures: IItemList;
}//end:

interface MetricsRowDataProps{
  metricsRowData: IMetricsRowData;
}//end:





const imageData = [
  { src: "https://placehold.co/600x400", caption: "Caption for Image 1" },
  { src: "https://placehold.co/600x401", caption: "Caption for Image 2" },
  { src: "https://placehold.co/600x402", caption: "Caption for Image 3" },
  // { src: "https://placehold.co/600x404", caption: "Caption for Image 4" },
];





const Header: React.FC = () => (
  <header>
    <div className="navbar navbar-dark bg-dark box-shadow">
      <div className="container d-flex justify-content-between">
        <a href="#" className="navbar-brand d-flex align-items-center">
          <strong>Album</strong>
        </a>
      </div>
    </div>
  </header>
);

const Jumbotron: React.FC = () => (
  <section className="jumbotron text-center">
    <div className="container">
      <h1 className="jumbotron-heading">Album example</h1>
      <p className="lead text-muted">
        Something short and leading about the collection below—its contents,
        the creator, etc. Make it short and sweet, but not too short so folks
        don’t simply skip over it entirely.
      </p>
      <p>
        <a href="#" className="btn btn-primary my-2">
          Main call to action
        </a>
        <a href="#" className="btn btn-secondary my-2 ml-2">
          Secondary action
        </a>
      </p>
    </div>
  </section>
);

interface CardProps {
  index: number;
}

const Card: React.FC<CardProps> = ({ index }) => (
  <div className="col-md-4">
    <div className="card mb-4 box-shadow rounded-lg">
      <svg
        className="bd-placeholder-img card-img-top"
        width="100%"
        height="225"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid slice"
        role="img"
        aria-label={`Placeholder: Thumbnail ${index}`}
      >
        <title>Placeholder</title>
        <rect width="100%" height="100%" fill="#55595c" />
        <text x="50%" y="50%" fill="#eceeef" dy=".3em" textAnchor="middle">
          Thumbnail {index}
        </text>
      </svg>
      <div className="card-body">
        <p className="card-text">
          This is a wider card with supporting text below as a natural lead-in
          to additional content. This content is a little bit longer.
        </p>
        <div className="d-flex justify-content-between align-items-center">
          <div className="btn-group">
            <button type="button" className="btn btn-sm btn-outline-secondary">
              View
            </button>
            <button type="button" className="btn btn-sm btn-outline-secondary">
              Edit
            </button>
          </div>
          <small className="text-muted">9 mins</small>
        </div>
      </div>
    </div>
  </div>
);

const Album: React.FC = () => (
  <div className="album py-5 bg-light">
    <div className="container">
      <div className="row">
        {Array.from({ length: 9 }, (_, i) => (
          <Card key={i} index={i + 1} />
        ))}
      </div>
    </div>
  </div>
);

const Footer: React.FC = () => (
  <footer className="text-muted">
    <div className="container">
      <p className="float-right">
        <a href="#">Back to top</a>
      </p>
      <p>
        Album example is &copy; Bootstrap, but please download and customize it
        for yourself!
      </p>
      <p>
        New to Bootstrap?{" "}
        <a href="https://getbootstrap.com/">Visit the homepage</a>.
      </p>
    </div>
  </footer>
);

const App: React.FC = () => (
  <>
    <Header />
    <main role="main">
      <Jumbotron />
      <Album />
    </main>
    <Footer />
  </>
);



const HomePage_v01: React.FC<AppConfigProps> = ({appConfig}) => {

  return (
    <>
      <NavBar_v03Responsive appConfig={appConfig} />
      <div className='container-fluid mt-5'>
      <h2>HomePage_v01a</h2>
        <p>Welcome to INS MASTER. v01a</p> 
        {/* <Carousel_v02 images={['https://placehold.co/600x400','https://placehold.co/600x401','https://placehold.co/600x402','https://placehold.co/600x403','https://placehold.co/600x404']}></Carousel_v02> */}

      </div>

    </>
  );
};



//const HomePage: React.FC<HomePageProps> = ({ title, subtitle, onButtonClick }) => {

const HomePage_v02: React.FC<AppConfigProps> = ({appConfig}) => {
  
  const myStyleRow1 = {
    fontSize: '8rem',
    fontWeight: 'bold',
    color: '#3498db',
  };
  const myStyle = {
    fontSize: '8rem',
    fontWeight: 'bold',
    
  };


  return (
    <>
      <NavBar_v03Responsive appConfig={appConfig} />
      <div className='container-fluid mt-5'>
      <h2>appConfig.companyDisplayName</h2>
        <p>Welcome to INS MASTER. v01a</p> 
        {/* <Carousel_v02 images={['/VendingMachind01-unsplash.jpg','https://placehold.co/600x401','https://placehold.co/600x402','https://placehold.co/600x403','https://placehold.co/600x404']}></Carousel_v02> */}
      </div>

      

      <div>

   


      
            {/* ROW ============================================ */}
            <div className="row p-5">
              
              <div className="col">
                
                                      <div className="card">
                                        <div className="card-body">
                                          <img src='../../public/VendingMachind01-unsplash.jpg'></img>
                                          <div className="text-center" style={myStyleRow1}>Card 1</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>

              </div>
              <div className="col">

                                      <div className="card" style={{width: '18rem;'}}>
                                        <div className="card-body">
                                        <div className="text-center" style={myStyleRow1}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>



              </div>
              <div className="col">

                                      <div className="card" style={{width: '18rem;'}}>
                                        <div className="card-body">
                                        <div className="text-center" style={myStyleRow1}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>


              </div>
              <div className="col">

                                      <div className="card">
                                        <div className="card-body">
                                        <div className="text-center" style={myStyleRow1}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>

              </div>
            </div>






   {/* ROW ============================================ */}
   <div className="row p-5">
              
              <div className="col">
                
                                      <div className="card">
                                        <div className="card-body">
                                          <div className="text-center" style={myStyle}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>

              </div>
              <div className="col">

                                      <div className="card" style={{width: '18rem;'}}>
                                        <div className="card-body">
                                        <div className="text-center" style={myStyle}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>



              </div>
              <div className="col">

                                      <div className="card" style={{width: '18rem;'}}>
                                        <div className="card-body">
                                        <div className="text-center" style={myStyle}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>


              </div>
              <div className="col">

                                      <div className="card">
                                        <div className="card-body">
                                        <div className="text-center" style={myStyle}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>

              </div>
            </div>






               {/* ROW ============================================ */}
               <div className="row p-5">
              
              <div className="col">
                
                                      <div className="card" style={{width: '18rem;'}}>
                                        <div className="card-body">
                                          <div className="text-center" style={myStyle}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>

              </div>
              <div className="col">

                                      <div className="card" style={{width: '18rem;'}}>
                                        <div className="card-body">
                                        <div className="text-center" style={myStyle}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>



              </div>
              <div className="col">

                                      <div className="card" style={{width: '18rem;'}}>
                                        <div className="card-body">
                                        <div className="text-center" style={myStyle}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>


              </div>
              <div className="col">

                                      <div className="card">
                                        <div className="card-body">
                                        <div className="text-center" style={myStyle}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>

              </div>
            </div>






               {/* ROW ============================================ */}
               <div className="row p-5">
              
              <div className="col">
                
                                      <div className="card" style={{width: '18rem;'}}>
                                        <div className="card-body">
                                          <div className="text-center" style={myStyle}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>

              </div>
              <div className="col">

                                      <div className="card" style={{width: '18rem;'}}>
                                        <div className="card-body">
                                        <div className="text-center" style={myStyle}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>



              </div>
              <div className="col">

                                      <div className="card" style={{width: '18rem;'}}>
                                        <div className="card-body">
                                        <div className="text-center" style={myStyle}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>


              </div>
              <div className="col">

                                      <div className="card">
                                        <div className="card-body">
                                        <div className="text-center" style={myStyle}>card title</div>
                                          {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                                        </div>
                                      </div>

              </div>
            </div>




            
            {/* ROW ============================================ */}
            <div className="row">
        
                                  <div className="col">
                                    
                                                          <div className="card" style={{width: '18rem;'}}>
                                                          <img className="card-img-top" src="..." alt="Card image cap"></img>
                                                            <div className="card-body">
                                                              <h5 className="card-title">Card title</h5>
                                                              <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                                              <a href="#" className="btn btn-primary">Go somewhere</a>
                                                            </div>
                                                          </div>

                                  </div>
                                  <div className="col">

                                                        <div className="card" style={{width: '18rem;'}}>
                                                          <img className="card-img-top" src="..." alt="Card image cap"></img>
                                                            <div className="card-body">
                                                              <h5 className="card-title">Card title</h5>
                                                              <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                                              <a href="#" className="btn btn-primary">Go somewhere</a>
                                                            </div>
                                                          </div>
                                  </div>
                                  <div className="col">
                                                          <div className="card" style={{width: '18rem;'}}>
                                                          <img className="card-img-top" src="..." alt="Card image cap"></img>
                                                            <div className="card-body">
                                                              <h5 className="card-title">Card title</h5>
                                                              <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                                              <a href="#" className="btn btn-primary">Go somewhere</a>
                                                            </div>
                                                          </div>
                            
                                  </div>
                                  <div className="col">
                                                        <div className="card" style={{width: '18rem;'}}>
                                                          <img className="card-img-top" src="..." alt="Card image cap"></img>
                                                            <div className="card-body">
                                                              <h5 className="card-title">Card title</h5>
                                                              <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                                              <a href="#" className="btn btn-primary">Go somewhere</a>
                                                            </div>
                                                          </div>
                            
                                  </div>
            </div>






        {/* END OF ROWS ========================================== */}
        </div>
    </>
  );
};



const HomePage_v02aInsurance: React.FC<AppConfigProps> = ({appConfig}) => {

  return (
    <>
      <NavBar_v03Responsive appConfig={appConfig} />
      
      
      <div className='container-fluid mt-5'>
      <h2>HomePage_v02a insurance</h2>
        <p>Welcome to INS MASTER. v02a</p> 
        {/* <Carousel_v02 images={['https://placehold.co/600x400','https://placehold.co/600x401','https://placehold.co/600x402','https://placehold.co/600x403','https://placehold.co/600x404']}></Carousel_v02> */}

      </div>

    </>
  );
};



let lCarouselData_Vending = [

    {"title": "Vending Benefits", 
    "content": "Fresh stnacks and cold drinks are an awesome benefit to everyone who visits your properties. We offer the latest in vending technologies and best in class support and service.", 
    "image":"/IMG-VendingMachind01-unsplash.jpg"},

    {"title": "Safe and affordiable", 
      "content": "Safe and affordiable benefit to you employees.", 
      "image":"/IMG-VENDING-MACHINE-02-AdobeStock_1081809176_Editorial_Use_Only.jpg"},

    {"title": "High Tech", 
      "content": "The latest technology in AI vending / Micro markets..", 
      "image":"/IMG-AI-VENDING-01-AdobeStock_1008969090.jpg"},

    {"title": "Refreshing", 
      "content": "Refresh and recharge in your break room - improving employee productivity.", 
      "image":"/IMG-BREAK-ROOM-AdobeStock_1082705275.jpg"},

      {"title": "Next Level Break Room", 
        "content": "Refresh and recharge in your break room - improving employee productivity.", 
        "image":"/IMG-VENDING-01-AdobeStock_1044781462.jpg"},
  

];


const metricsRowData : IMetricsRowData =  {
  Headline : "Industry Metrics",
  Rows: [
          { 
            Title: 'Drinks',
            SubTitle: 'Soda, water, energy drinks',
            Text: '40–45%'
          },
          { 
            Title: 'Snacks',
            SubTitle: 'Chips, candy',
            Text: '35–40%'
          },
          { 
            Title: 'Healthy Options',
            SubTitle: 'Nuts, protein bars, low-sugar snacks - a growing segment',
            Text: '10–15%'
          },
          { 
            Title: 'Non-food',
            SubTitle: 'Personal Protective Equipment (PPE) -  safety glasses, hard hat sun shades, tool lanyards etc., tech accessories, Over The Counter (OTC) medications - an emerging trend',
            Text: '2–5%'
          },
        ]
}; //end:

let lAnnma:ReactNode = <span>According to <a href='https://namanow.org/' title='(National Automatic Merchandising Association)'>NAMA</a></span>


// IMG-VENDING-MACHINE-02-AdobeStock_1081809176_Editorial_Use_Only.jpg
const featuresVending: IItemList = {
  Id: 1,
  Title: "Vending Serivce Features and benefits",
  Items: [
    {
      Title: "Fresh, Cold/Hot and satisfying",
      Description: "Fresh snacks and cold drinks are an awesome benefit to everyone who visits your property.",
      ImageLink: "/sundance-images/IMG-AdobeStock_872312240-water-vend.jpg",
      AltText: "",
      ItemFacts: [
                    {
                        Title: "Fresh and Healthy is in Demand",
                        Description: "Over 60% of millennials and Gen Z consumers actively seek healthier snack options, including fresh fruit, protein bars, low-sugar drinks, and plant-based snacks (Source: Vending Market Watch, 2023). Having fresh vending options meets modern dietary preferences while showing that your property supports wellness.",
                    },
                    {
                        Title: "Cold Drinks Boost Satisfaction",
                        Description: <span>{lAnnma}, beverages—especially bottled water, sodas, and energy drinks—make up nearly 45% of all vending sales. A cold drink on a hot day can increase dwell time and comfort, particularly in high-traffic areas like gyms, offices, or apartment lounges.</span>,
                    },
                    {
                        Title: "Hot Coffee and Snacks Encourage Repeat Visits",
                        Description: "Hot beverage vending machines (especially coffee, espresso, and tea) have seen growing adoption in corporate and shared spaces. Offering high-quality hot drinks in common areas creates a coffee-shop experience and improves workplace morale or tenant loyalty.",
                    },
                    {
                        Title: "Strategic Placement = Higher Usage",
                        Description: "Vending machines placed in easily visible and accessible locations (near entrances, lounges, or lobbies) are more likely to be used multiple times a day. This contributes to increased foot traffic, repeat visits, and even higher perceived value of the space.",
                    },
                    ]
    },
    {
      Title: "Safe and affordiable",
      Description: "Safe, affordiable and valueable benefit to you employees, customers and suppliers.",
      ImageLink: "/sundance-images/IMG-AI-VENDING-01-AdobeStock_1008969090.jpg",
      AltText: "",
      ItemFacts: [
                    {
                        Title: "Contactless and Hygienic",
                        Description: <span>Modern vending machines are equipped with touchless payment options (Apple Pay, Google Pay, RFID, etc.), reducing physical contact and supporting hygiene-conscious environments. According to {lAnnma}, machines that offer contactless payment have seen a 30%+ increase in usage post-COVID (NAMA 2022 Industry Census).</span>,
                    },
                    {
                        Title: "Secure, Tamper-Resistant Design",
                        Description: "Vending machines are built with reinforced locks, tempered glass, and surveillance compatibility. Many commercial-grade machines include anti-vandalism features and are securely anchored, making them safe for high-traffic environments like schools, factories, and transportation hubs.",
                    },
                    {
                        Title: "No Staffing Required",
                        Description: "Because machines are automated and remotely monitored, you eliminate the need for on-site staff or food handling. This makes vending a low-risk and low-maintenance solution for delivering food or beverages.",
                    }
                    ]
    },
    {
      Title: "High Tech / High Touch",
      Description: "The latest technology in vending & Micro markets / Internet & AI aware.",
      ImageLink: "/sundance-images/IMG-VENDING-01-AdobeStock_1044781462.jpg",
      AltText: "",
      ItemFacts: [
                    {
                        Title: "Smart vending - seamless, modern experience",
                        Description: "The latest technology in vending and micro markets is transforming how people access snacks, drinks, and essentials. Today’s smart vending systems are not only sleek and user-friendly — they’re Internet-connected, AI-aware, and built for convenience. This combination of high tech and high touch creates a seamless, modern experience for customers while offering powerful tools and insights for operators and property owners.",
                    },
                    {
                        Title: "Connected to the Internet of Things (IoT)",
                        Description: <span>
                              Modern vending machines are now fully connected to the internet, allowing real-time updates, inventory tracking, and remote maintenance. Operators can monitor stock levels, receive alerts for outages, and even optimize product mix based on buying trends — all remotely.

                              <div className="mt-2 ms-2"><b>Fact:</b> Over 60% of vending machines in the U.S. are now internet-connected, according to Vending Market Watch (2023).</div>
                        </span>,
                    },

       {
                        Title: "Micro Markets: High-Touch Shopping Without the Staff",
                        Description: <span>
                              Micro markets are unattended convenience stores that offer fresh food, drinks, and daily essentials in secure, self-checkout kiosks. They combine vending automation with a retail-like experience—giving customers the freedom to browse, scan, and pay.

                              <div className="mt-2 ms-2"><b>Fact:</b> Micro market installations have grown by 15–20% annually in workplaces and campuses across the U.S. (<a href='https://www.vendingmarketwatch.com/home/company/10283278/automatic-merchandiser-vendingmarketwatch'>Automatic Merchandiser</a> 2023 Report).</div>
                        </span>,
                    },


                    
                    

                    


                    ]
      },
      {
      Title: "Refreshing break rooms",
      Description: "Refresh and recharge in your break room.  Studies show, improved employee productivity and satisfaction.",
      ImageLink: "/sundance-images/IMG-BREAK-ROOM-AdobeStock_1082705275.jpg",
      AltText: "",
      ItemFacts: [
                    {
                        Title: "Boosts Productivity & Satisfaction",
                        Description: "According to a study by the Harvard Business Review, short breaks every 90–120 minutes help employees reset mentally, reduce burnout, and improve focus. Having vending machines in the break room makes those breaks quicker and more accessible, so employees return to work energized.",
                    },
        ]
    },

  ],
};



const HomePage_v02aVending: React.FC<AppConfigProps> = ({appConfig}) => {
  
  return (
    <>
        <div className='container-fluid mt-0 my-homePage'>
        <Carousel_v06_basic items={homePage_carouselItems_Vending}></Carousel_v06_basic>
        {/* <p>Welcome to {appConfig.companyDisplayName} Master v02a</p>  */}
        {/* <Features_v01 appFeatures={featuresVending}></Features_v01> */}
        <Features_v01Accordian appFeatures={featuresVending}></Features_v01Accordian>
        <MetricsRow_v01 metricsRowData={metricsRowData} cssValue={appConfig.HomePageMetrcsCSSValue}></MetricsRow_v01>
      </div>
    </>
  );
};


const HomePage_v02aGratitude: React.FC<AppConfigProps> = ({appConfig}) => {

  return (
    <>
      
      <NavBar_v03Responsive appConfig={appConfig} />
      <div className='container-fluid mt-5'>
      <h2>HomePage_v02aGratitude</h2>
        <p>Welcome to Gratitude Master v02a</p> 
        {/* <Carousel_v02 images={['https://placehold.co/600x400','https://placehold.co/600x401','https://placehold.co/600x402','https://placehold.co/600x403','https://placehold.co/600x404']}></Carousel_v02> */}
      </div>
    </>
  );
};



export default HomePage_v02aVending;



{/* <HalfImageHalfText></HalfImageHalfText> */}
{/* <Carousel_v01></Carousel_v01> */}
{/* <Carousel_v03 images={['https://placehold.co/600x400','https://placehold.co/600x401','https://placehold.co/600x402','https://placehold.co/600x403','https://placehold.co/600x404']}></Carousel_v03> */}

{/* <Carousel_v05 images={imageData}></Carousel_v05> */}

        










{/* <div id="carouselExampleCaptions" className="carousel slide slideTest">
<div className="carousel-indicators">
  <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
  <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
  <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
</div>
<div className="carousel-inner">
  <div className="carousel-item active">
    <img src="..." className="d-block w-100" alt="..."></img>
    <div className="carousel-caption d-none d-md-block">
      <h5>First slide label</h5>
      <p>Some representative placeholder content for the first slide.</p>
    </div>
  </div>
  <div className="carousel-item">
    <img src="..." className="d-block w-100" alt="..."></img>
    <div className="carousel-caption d-none d-md-block">
      <h5>Second slide label</h5>
      <p>Some representative placeholder content for the second slide.</p>
    </div>
  </div>
  <div className="carousel-item">
    <img src="..." className="d-block w-100" alt="..."></img>
    <div className="carousel-caption d-none d-md-block">
      <h5>Third slide label</h5>
      <p>Some representative placeholder content for the third slide.</p>
    </div>
  </div>
</div>
<button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
  <span className="visually-hidden">Previous</span>
</button>
<button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
  <span className="carousel-control-next-icon" aria-hidden="true"></span>
  <span className="visually-hidden">Next</span>
</button>
</div> */}






















// const carouselItems = [
//   {
//     //srcDesktop: 'https://placehold.co/1200x500?text=Desktop+1',
//     srcDesktop: "/VendingMachind01-unsplash.jpg",
    

//     srcMobile: 'https://placehold.co/600x300?text=Mobile+1',
//     alt: 'Slide 1',
//     captionTitle: 'Responsive Slide 1',
//     captionText: 'Desktop and mobile images!',
//   },
//   {
//     srcDesktop: 'https://placehold.co/1200x500?text=Desktop+2',
//     srcMobile: 'https://placehold.co/600x300?text=Mobile+2',
//     alt: 'Slide 2',
//     captionTitle: 'Responsive Slide 2',
//     captionText: 'Different image per device.',
//   },
//   {
//     srcDesktop: 'https://placehold.co/1200x500?text=Desktop+3',
//     srcMobile: 'https://placehold.co/600x300?text=Mobile+3',
//     alt: 'Slide 3',
//     captionTitle: 'Responsive Slide 3',
//     captionText: 'Mobile-friendly design.',
//   },
// ];

const carouselItems_xx = [
  {
    //srcDesktop: 'https://placehold.co/1200x500?text=Desktop+1',
    srcDesktop: "/VendingMachind01-unsplash.jpg",
    

    srcMobile: 'sundance-images/IMG-https://placehold.co/600x300?text=Mobile+1',
    alt: 'Slide 1',
    captionTitle: 'Responsive Slide 1',
    captionText: 'Desktop and mobile images!',
  },
  {
    srcDesktop: "/sundance-images/IMG-VENDING-MACHINE-02-AdobeStock_1081809176_Editorial_Use_Only.jpg",
    srcMobile: 'https://placehold.co/600x300?text=Mobile+2',
    alt: 'Slide 2',
    captionTitle: 'Responsive Slide 2',
    captionText: 'Different image per device.',
  },
  {
    srcDesktop: '/sundance-images/IMG-AI-VENDING-01-AdobeStock_1008969090.jpg',
    srcMobile: 'https://placehold.co/600x300?text=Mobile+3',
    alt: 'Slide 3',
    captionTitle: 'Responsive Slide 3',
    captionText: 'Mobile-friendly design.',
  },
  {
    srcDesktop: '/sundance-images/IMG-BREAK-ROOM-AdobeStock_1082705275.jpg',
    srcMobile: 'https://placehold.co/600x300?text=Mobile+3',
    alt: 'Slide 4',
    captionTitle: 'Responsive Slide 4',
    captionText: 'Mobile-friendly design.',
  },
];
